export const BOOKED_HOURS_COLOR = "#4a3aa7";
export const FREE_HOURS_COLOR = "#9085e9";
export const HEATMAP_RAMP = [
  "#b2aaf1",
  "#968be6",
  "#7a6dd6",
  "#5f50bf",
  "#4a3aa7",
] as const;
